export const DISCOGS_BASE_URL = 'https://www.discogs.com'

export const CONDITION_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'M', label: 'Mint (M)' },
  { value: 'NM', label: 'Near Mint (NM)' },
  { value: 'VG+', label: 'Very Good Plus (VG+)' },
  { value: 'VG', label: 'Very Good (VG)' },
] as const

export const RATING_OPTIONS = [
  { value: '', label: 'Any' },
  { value: '99', label: '99%+' },
  { value: '98', label: '98%+' },
  { value: '95', label: '95%+' },
] as const

export const DEFAULT_PAGE_SIZE = 50

// Must match the generated Gem Score formula in server/db.ts.
export const GEM_SCORE_FULL_CONFIDENCE_WANTS = 500
export const GEM_SCORE_CONFIDENCE_FLOOR = 0.25

export function calculateGemScore(baseScore: number | null, wants: number | null): number | null {
  if (baseScore == null) return null
  const demandConfidence = Math.min(1, Math.max(0, wants ?? 0) / GEM_SCORE_FULL_CONFIDENCE_WANTS)
  return baseScore * (GEM_SCORE_CONFIDENCE_FLOOR + (1 - GEM_SCORE_CONFIDENCE_FLOOR) * demandConfidence)
}

export const PAGE_SIZE_OPTIONS = [25, 50, 100] as const

export const PROFIT_THRESHOLDS = {
  EXCELLENT: 20,
  GOOD: 10,
  MODERATE: 5,
} as const

export const PROFIT_MARGIN_THRESHOLDS = {
  EXCELLENT: 0.3,
  GOOD: 0.2,
  MODERATE: 0.1,
} as const

export const KEYBOARD_SHORTCUTS = {
  NEXT_LISTING: ['j', 'ArrowDown'],
  PREV_LISTING: ['k', 'ArrowUp'],
  ADD_TO_CART: ['a'],
  OPEN_ON_DISCOGS: ['Enter'],
  DESELECT: ['Escape'],
  TOGGLE_CART: ['c'],
  SEARCH_FOCUS: ['/'],
} as const

export function getDiscogsListingUrl(uri: string): string {
  return `${DISCOGS_BASE_URL}${uri}`
}

export function getDiscogsReleaseUrl(releaseId: number): string {
  return `${DISCOGS_BASE_URL}/release/${releaseId}`
}

export function getProfitLevel(profit: number): 'excellent' | 'good' | 'moderate' | 'low' {
  if (profit >= PROFIT_THRESHOLDS.EXCELLENT) return 'excellent'
  if (profit >= PROFIT_THRESHOLDS.GOOD) return 'good'
  if (profit >= PROFIT_THRESHOLDS.MODERATE) return 'moderate'
  return 'low'
}

export function getMarginLevel(margin: number): 'excellent' | 'good' | 'moderate' | 'low' {
  if (margin >= PROFIT_MARGIN_THRESHOLDS.EXCELLENT) return 'excellent'
  if (margin >= PROFIT_MARGIN_THRESHOLDS.GOOD) return 'good'
  if (margin >= PROFIT_MARGIN_THRESHOLDS.MODERATE) return 'moderate'
  return 'low'
}
